import styled from "styled-components";

export const MainDiv = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
`;
export const Header = styled.div`
  padding: 0 0 0 8px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  position: relative;
  z-index: 1;
`;
export const Title = styled.p`
  color: #000;
  font-size: 14px;
`;
export const Span = styled.span`
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const OpenButton = styled.button`
  width: 33px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  border-left: 2px solid rgb(230, 230, 230);
  background: transparent;
  position: absolute;
  right: 0;
  cursor: pointer;
`;
export const OpenButtonImg = styled.img`
  width: 15px;
  height: 15px;
`;
